import React from 'react';
import Typography from '@mui/material/Typography';

export default function NoMatch () {
    return (
        <Typography mt={10} fontSize={50} textAlign="center">
            Oops, the page you requested does not exist!
        </Typography>
    )
} 